var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.962891 40.1503L7.08894 1.02716C7.16383 0.547353 7.53772 0.169114 8.01741 0.087781C8.4971 0.00644822 8.97512 0.240441 9.20448 0.66867L15.5399 12.462L18.0652 7.66337C18.2607 7.29233 18.6463 7.06 19.0664 7.06C19.4865 7.06 19.872 7.29233 20.0676 7.66337L37.1646 40.1503L0.962891 40.1503Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1905 25.0072L15.5808 12.5159L0.962891 40.293L22.1905 25.0072Z",
    fill: "#F57C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1646 40.4054L32.4725 11.4274C32.4016 11.0112 32.1041 10.6694 31.7011 10.5405C31.2981 10.4117 30.8571 10.5189 30.5578 10.8173L0.962891 40.405L17.3385 49.5704C18.3668 50.1434 19.6192 50.1434 20.6475 49.5704L37.1646 40.405V40.4054Z",
    fill: "#FFCA28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.475 11.0938C32.4042 10.6779 32.1068 10.3362 31.704 10.2074C31.3013 10.0786 30.8605 10.1858 30.5614 10.484L24.6907 16.3581L20.0742 7.58681C19.8788 7.21598 19.4935 6.98378 19.0736 6.98378C18.6537 6.98378 18.2684 7.21598 18.0729 7.58681L15.549 12.3828L9.21682 0.596165C8.9872 0.168059 8.50888 -0.0654262 8.02888 0.0164678C7.54889 0.0983617 7.17646 0.477339 7.10245 0.957263L0.982626 40.056H0.962891L0.982626 40.0786L1.14374 40.1576L30.5528 10.7722C30.8518 10.4723 31.2937 10.3646 31.6975 10.493C32.1013 10.6214 32.3992 10.9644 32.4694 11.3815L37.1193 40.0842L37.1646 40.0559L32.475 11.0938ZM1.03633 40.0024L7.1053 1.23378C7.17923 0.753854 7.55254 0.374877 8.03211 0.292983C8.51169 0.211089 8.99005 0.444498 9.22004 0.87268L15.5516 12.6595L18.0754 7.86351C18.2709 7.49268 18.6562 7.26048 19.0761 7.26048C19.496 7.26048 19.8813 7.49268 20.0768 7.86351L24.5995 16.4484L1.03633 40.0024Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6476 49.2472C19.6192 49.8202 18.3669 49.8202 17.3385 49.2472L1.0025 40.1073L0.962891 40.3586L17.3385 49.5211C18.3668 50.0942 19.6192 50.0942 20.6475 49.5211L37.1646 40.3586L37.1222 40.0989L20.6476 49.2472Z",
    fill: "#A52714"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4745 11.2285C32.4036 10.8113 32.1062 10.4683 31.7034 10.3398C31.3007 10.2113 30.8598 10.3181 30.5607 10.6173L24.6894 16.5093L20.0731 7.71086C19.8776 7.33885 19.4922 7.10591 19.0724 7.10591C18.6525 7.10591 18.2672 7.33885 18.0717 7.71086L15.5473 12.5219L9.21514 0.698134C8.98547 0.268693 8.50716 0.0344152 8.02755 0.116639C7.54795 0.198862 7.1746 0.578885 7.10068 1.0604L0.980469 40.2811L17.348 49.4673C18.3758 50.0418 19.6276 50.0418 20.6554 49.4673L37.1643 40.2811L32.4745 11.2284V11.2285Z",
    fill: "url(#paint0_linear_401_127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_127",
    x1: -125.301,
    y1: 847.659,
    x2: 4386.26,
    y2: 3232.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.0a539755b8c7b3a71fe997ee73514c1b.svg";
export { ForwardRef as ReactComponent };